import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-tabs-tab"
}
const _hoisted_2 = {
  key: 0,
  class: "c-tabs-tab"
}

import { inject, onMounted, ref, watch, } from 'vue';


const __default__ = {
  name: 'CTabPane'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    name: {},
    title: {},
    keepAlive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
// const TabsInstance = inject('TabsInstance') as any
const ininTabs = inject('ininTabs', Function, true)
const activeKey = inject('activeKey');
onMounted(() => {
  // console.log(TabsInstance, 'TabsInstance')
  ininTabs()
})
watch(() => props.name, () => {
  // TabsInstance.ctx.initTabs()
  ininTabs()
})
watch(() => props.title, () => {
  // TabsInstance.ctx.initTabs()
  ininTabs()
})

return (_ctx: any,_cache: any) => {
  return (_ctx.keepAlive)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)), [
        [_vShow, _ctx.name == _unref(activeKey)]
      ])
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.name == _unref(activeKey))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ], 64))
}
}

})